import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/(iliad)/about": [45,[5]],
		"/account-settings": [58],
		"/activate-early-access": [59],
		"/auth/action": [60],
		"/(iliad)/boards": [46,[5]],
		"/(iliad)/boards/[id]": [47,[5]],
		"/(iliad)/canvas": [48,[5]],
		"/(aqueduct)/conformance": [9,[2,3]],
		"/(aqueduct)/conformance/main": [10,[2,3]],
		"/(aqueduct)/conformance/memory": [11,[2,3]],
		"/(aqueduct)/conformance/worker": [12,[2,3]],
		"/(aqueduct)/design-system/brand-capture": [14,[2]],
		"/(aqueduct)/design-system/brand": [13,[2]],
		"/(aqueduct)/design-system/editor-capture": [15,[2]],
		"/(aqueduct)/design-system/heading-gradients": [16,[2]],
		"/(aqueduct)/design-system/node-visuals": [17,[2]],
		"/(aqueduct)/docs": [18,[2,4]],
		"/(aqueduct)/docs/custom-nodes": [19,[2,4]],
		"/(aqueduct)/docs/materials": [20,[2,4]],
		"/(aqueduct)/docs/mcp": [21,[2,4]],
		"/(aqueduct)/docs/nodes": [22,[2,4]],
		"/(aqueduct)/docs/nodes/[name]": [23,[2,4]],
		"/(aqueduct)/docs/projects": [24,[2,4]],
		"/(aqueduct)/docs/snapshots": [25,[2,4]],
		"/(aqueduct)/docs/support": [26,[2,4]],
		"/(aqueduct)/docs/time-expressions": [27,[2,4]],
		"/(aqueduct)/docs/unreal": [28,[2,4]],
		"/(aqueduct)/early-access-codes": [29,[2]],
		"/(aqueduct)/examples/g/[id]": [30,[2]],
		"/(aqueduct)/examples/m/[id]": [31,[2]],
		"/(aqueduct)/g/[id=uuid]": [~32,[2]],
		"/(iliad)/(seo)/image-generator": [41,[5]],
		"/ja": [61,[6]],
		"/ja/account-settings": [62,[6]],
		"/ja/activate-early-access": [63,[6]],
		"/ja/auth/action": [64,[6]],
		"/ja/docs": [65,[6,7]],
		"/ja/docs/custom-nodes": [66,[6,7]],
		"/ja/docs/materials": [67,[6,7]],
		"/ja/docs/mcp": [68,[6,7]],
		"/ja/docs/nodes": [69,[6,7]],
		"/ja/docs/nodes/[name]": [70,[6,7]],
		"/ja/docs/projects": [71,[6,7]],
		"/ja/docs/snapshots": [72,[6,7]],
		"/ja/docs/support": [73,[6,7]],
		"/ja/docs/time-expressions": [74,[6,7]],
		"/ja/docs/unreal": [75,[6,7]],
		"/ja/examples/g/[id]": [76,[6]],
		"/ja/examples/m/[id]": [77,[6]],
		"/ja/g/[id=uuid]": [~78,[6]],
		"/ja/local-example": [80,[6]],
		"/ja/local": [79,[6]],
		"/ja/login": [81,[6]],
		"/ja/m/[id=uuid]": [~82,[6]],
		"/ja/oauth/consent": [83,[6]],
		"/ja/pricing": [84,[6]],
		"/ja/privacy-policy": [85,[6]],
		"/ja/projects": [86,[6]],
		"/ja/projects/[id]": [87,[6]],
		"/ja/reset-password": [88,[6]],
		"/ja/sign-up": [89,[6]],
		"/ja/start": [90,[6]],
		"/ja/terms-of-service": [91,[6]],
		"/ja/workspace/[id=uuid]": [92,[6]],
		"/(iliad)/journeys": [49,[5]],
		"/(iliad)/journeys/[id]": [~50,[5]],
		"/(iliad)/library-3d": [52,[5]],
		"/(iliad)/library": [51,[5]],
		"/(aqueduct)/local-example": [34,[2]],
		"/(aqueduct)/local": [33,[2]],
		"/login": [93],
		"/(iliad)/material-generator": [53,[5]],
		"/(aqueduct)/m/[id=uuid]": [~35,[2]],
		"/oauth/consent": [94],
		"/(iliad)/(utilities)/pbr-material-visualizer": [43,[5]],
		"/(iliad)/plan": [54,[5]],
		"/(aqueduct)/pricing": [36,[2]],
		"/privacy-policy": [95],
		"/(aqueduct)/projects": [37,[2]],
		"/(aqueduct)/projects/[id]": [38,[2]],
		"/(iliad)/reference-to-texture": [55,[5]],
		"/reset-password": [96],
		"/(iliad)/(utilities)/seamless-texture-checker": [44,[5]],
		"/(iliad)/(seo)/seamless-texture-generator": [42,[5]],
		"/sign-up": [97],
		"/(aqueduct)/start": [39,[2]],
		"/terms-of-service": [98],
		"/(iliad)/textures/[id]": [~56,[5]],
		"/(iliad)/utilities": [57,[5]],
		"/(aqueduct)/workspace/[id=uuid]": [40,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';